import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_task_details_by_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { task_id: number }): 
  Promise<{ result: { Id?: number, ActualExpirationDate?: string, ActualInventoryAmount?: number, ActualInventoryAmountPackId?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ChainHead?: number, ExpectedExpirationDate?: string, ExpectedInventoryAmount?: number, ExpectedInventoryAmountPackId?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSerialNumberId?: number, ExpectedSourceLicensePlateId?: number, ExpectedSourceLocationId?: number, ExpectedTargetLicensePlateId?: number, ExpectedTargetLocationId?: number, LotId?: number, MaterialId?: number, PickSlipId?: number, SerialNumberId?: number, StatusId?: number, VendorLotId?: number, WarehouseId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.task_id)) {
      $missingRequiredInParams.push('\'task_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      task_id: number    }) {
        if(isNil($inParams.task_id)) {
          return true; 
        }
      return false;
    }
}
